// extracted by css-extract-rspack-plugin
export default {"root":"h9OMN0","link":"JBykw7"};